import type { StateCreator } from "zustand";
import type { FormulaTemplateOption } from "../hooks/useFormulaTemplates";
import type { VariableDefinitionOption } from "../hooks/useVariableDefinitions";
import type { OpDataVariableOption } from "../hooks/useOpDataCatalog";

export interface FormulaReferenceSlice {
  formulaTemplatesBySubCategory: Record<string, FormulaTemplateOption[]>;
  formulaTemplatesErrorBySubCategory: Record<string, Error>;
  variableDefinitions: VariableDefinitionOption[] | null;
  opDataCatalog: OpDataVariableOption[] | null;
  variableDefinitionsError: Error | null;
  opDataCatalogError: Error | null;
  setFormulaTemplates: (
    subCategoryId: string,
    templates: FormulaTemplateOption[],
  ) => void;
  setFormulaTemplatesError: (subCategoryId: string, error: Error) => void;
  setVariableDefinitions: (variables: VariableDefinitionOption[]) => void;
  setOpDataCatalog: (catalog: OpDataVariableOption[]) => void;
  setVariableDefinitionsError: (error: Error | null) => void;
  setOpDataCatalogError: (error: Error | null) => void;
}

export const formulaReferenceSlice: StateCreator<
  FormulaReferenceSlice,
  [["zustand/immer", never]],
  [],
  FormulaReferenceSlice
> = (set) => ({
  formulaTemplatesBySubCategory: {},
  formulaTemplatesErrorBySubCategory: {},
  variableDefinitions: null,
  opDataCatalog: null,
  variableDefinitionsError: null,
  opDataCatalogError: null,
  setFormulaTemplates: (subCategoryId, templates) =>
    set((s) => {
      s.formulaTemplatesBySubCategory[subCategoryId] = templates;
      delete s.formulaTemplatesErrorBySubCategory[subCategoryId];
    }),
  setFormulaTemplatesError: (subCategoryId, error) =>
    set((s) => {
      s.formulaTemplatesErrorBySubCategory[subCategoryId] = error;
    }),
  setVariableDefinitions: (variables) =>
    set((s) => {
      s.variableDefinitions = variables;
      s.variableDefinitionsError = null;
    }),
  setOpDataCatalog: (catalog) =>
    set((s) => {
      s.opDataCatalog = catalog;
      s.opDataCatalogError = null;
    }),
  setVariableDefinitionsError: (error) =>
    set((s) => {
      s.variableDefinitionsError = error;
    }),
  setOpDataCatalogError: (error) =>
    set((s) => {
      s.opDataCatalogError = error;
    }),
});
